import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { BaseSelectProps } from '~/components/inputs/Select/Select';
import SimpleSelect, { SimpleSelectOption } from '~/components/inputs/Select/SimpleSelect';
import IconInstitution from '~/icons/icon-building.svg?react';
import IconStore from '~/icons/icon-store.svg?react';
import IconBusinessman from '~/icons/icon-user-business.svg?react';
import IconContractor from '~/icons/icon-user-contractor.svg?react';
import { IdentityType } from '~/types/company-identity';
import styles from './IdentityTypeSelect.module.scss';

interface Props extends BaseSelectProps {
  onChange: (value: IdentityType) => void;
  value: IdentityType;
}

const IdentityTypeSelect: React.FC<Props> = forwardRef(
  ({ onChange, ...props }: Props, ref?: React.Ref<HTMLDivElement>) => {
    const { t } = useTranslation('counterparts');

    const options: SimpleSelectOption[] = [
      {
        value: IdentityType.Company,
        label: t('identities.company'),
        media: <IconStore className={styles.icon} />,
      },
      {
        value: IdentityType.Pa,
        label: t('identities.PA'),
        media: <IconInstitution className={styles.icon} />,
      },
      {
        value: IdentityType.Person,
        label: t('identities.person'),
        media: <IconBusinessman className={styles.icon} />,
      },
      {
        value: IdentityType.Contractor,
        label: t('identities.contractor'),
        media: <IconContractor className={styles.icon} />,
      },
    ];

    return (
      <SimpleSelect ref={ref} {...props} onChange={(value) => onChange(value as IdentityType)} options={options} />
    );
  },
);

export default IdentityTypeSelect;
